export function humbergerMenuButton(buttonEl, menuEl, closeEl) {
  if ($(buttonEl).length && $(closeEl).length) {
    $(buttonEl).on("click", function () {
      $(this).toggleClass("is-active");
      $(menuEl).toggleClass("is-active");
    });
    $(closeEl).on("click", function () {
      $(buttonEl).removeClass("is-active");
      $(menuEl).removeClass("is-active");
    });
  }

}
